import { render } from "./HomeView.vue?vue&type=template&id=159ff986&scoped=true"
import script from "./HomeView.vue?vue&type=script&lang=js"
export * from "./HomeView.vue?vue&type=script&lang=js"

import "./HomeView.vue?vue&type=style&index=0&id=159ff986&scoped=true&lang=less"

import exportComponent from "D:\\createProject\\吉幼美官网\\web\\project\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-159ff986"]])

export default __exports__